import { ArrowButton, BannerTile, ListerTile, VisualTile } from "@/components";
import { ContentLoader, Link, useI18n, useLastLister } from "@jog/react-components";
import { gtmProductClickOnLister } from "@jog/shared";
const Skeleton = () => (<div className="grid grid-cols-2 gap-3.5 px-2 lg:grid-cols-4">
        {Array(20)
        .fill(0)
        .map((_, index) => (<ContentLoader key={index} height="350px"/>))}
    </div>);
const TwTile = ({ items, onListerTile, getGroup, }) => {
    return (<>
            {items.map((item) => {
            var _a, _b;
            if (((_a = item.origin) === null || _a === void 0 ? void 0 : _a.name) === "visual" && ((_b = item.origin) === null || _b === void 0 ? void 0 : _b.type) === "content-merchandising") {
                return <VisualTile item={item} key={item.itemno}/>;
            }
            return <ListerTile key={item.itemno} data={item} group={getGroup(item)} onClick={onListerTile}/>;
        })}
        </>);
};
export const Products = ({ loaded, data, banners, getGroup, category, }) => {
    const { $t } = useI18n();
    const { recordLister } = useLastLister();
    const onListerTile = (item) => {
        gtmProductClickOnLister(item, category);
        recordLister(data.properties.pageurl, item.itemno);
    };
    if (!loaded || !data)
        return <Skeleton />;
    if (data.items.length === 0)
        return (<div className="text-base font-bold">
                <div className="mb-4">{$t("No items found")}</div>
                <Link href="/">
                    <ArrowButton>{$t("Continue shopping")}</ArrowButton>
                </Link>
            </div>);
    return (<div className="grid grid-flow-dense grid-cols-2 gap-3.5 px-2 md:grid-cols-4">
            <TwTile items={data.items.slice(0, 16)} onListerTile={onListerTile} getGroup={getGroup}/>
            <BannerTile banner={banners === null || banners === void 0 ? void 0 : banners[0]}/>
            <TwTile items={data.items.slice(16, 32)} onListerTile={onListerTile} getGroup={getGroup}/>
            <BannerTile banner={banners === null || banners === void 0 ? void 0 : banners[1]}/>
        </div>);
};
